import React from 'react';
import PropTypes from 'prop-types';

import BundleUtil from 'utils/BundleUtil';

import Typography from 'components/vistaprintUILibrary/Typography';

import checkmarkIconSrc from 'images/icons/checkmark.svg';

function ServiceHighlight(props) {
  const {
    text,
  } = props;

  return (
    <div
      style={{
        alignSelf: 'flex-start',
        display: 'flex',

        marginTop: 20,
      }}
    >
      <img
        src={BundleUtil.getFullyQualifiedURL(checkmarkIconSrc)}
        alt="Checkmark"
        style={{
          height: 8,
          width: 14,
          marginRight: 10,
        }}
      />
      <Typography
        text={text}
      />
    </div>
  );
}

ServiceHighlight.propTypes = {
  text: PropTypes.string.isRequired,
};

export default ServiceHighlight;



// WEBPACK FOOTER //
// ./src/components/ServiceHighlight.js